import { render, staticRenderFns } from "./maintemplate.vue?vue&type=template&id=6007b448&scoped=true"
import script from "./maintemplate.vue?vue&type=script&lang=js"
export * from "./maintemplate.vue?vue&type=script&lang=js"
import style0 from "./maintemplate.vue?vue&type=style&index=0&id=6007b448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6007b448",
  null
  
)

export default component.exports